var map = {
	"./all-you-can-eat-management-guide/metadata": [
		24604,
		4604
	],
	"./all-you-can-eat-ordering-system/metadata": [
		25025,
		5025
	],
	"./bakery-ordering-software/metadata": [
		12768,
		2768
	],
	"./bowling-alley-digital-ordering/metadata": [
		78047,
		8047
	],
	"./choosing-ordering-solution/metadata": [
		80735,
		735
	],
	"./choosing-self-ordering-kiosk-software/metadata": [
		13435,
		3435
	],
	"./commission-free-online-ordering/metadata": [
		65061,
		1414
	],
	"./golf-clubs-digital-ordering/metadata": [
		21332,
		1332
	],
	"./hotel-digital-ordering/metadata": [
		88633,
		8633
	],
	"./qr-ordering-implementation-guide/metadata": [
		76951,
		6951
	],
	"./qr-ordering-restaurant-guide/metadata": [
		28140,
		8140
	],
	"./restaurant-kpi-guide/metadata": [
		76619,
		6619
	],
	"./self-order-kiosks-for-hospitality/metadata": [
		29913,
		9913
	],
	"./snackbar-digital-ordering/metadata": [
		88466,
		8466
	],
	"./the-new-hospitality-industry/metadata": [
		82275,
		2275
	],
	"./the-psychology-behind-upselling/metadata": [
		64343,
		4343
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2547;
module.exports = webpackAsyncContext;